// extracted by mini-css-extract-plugin
module.exports = {"otherFormats":"_2R2Q18"};